import { render, staticRenderFns } from "./headerPtenAgent.vue?vue&type=template&id=5bb7ce3a&scoped=true"
import script from "./headerPtenAgent.vue?vue&type=script&lang=js"
export * from "./headerPtenAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7ce3a",
  null
  
)

export default component.exports